import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { matchPath, useHistory } from 'react-router-dom';
import { getOrderDetail } from '../../../api';
import getFormatMessage from '../../../locales/get-format-message';
import { IApiOrderListItem } from '../../../model/api-modules';
import styles from './index.module.scss';
import { SyncOutlined } from '@ant-design/icons';

import { OrderStatusConfig } from '../lib/service-order';
import { openContactMethod } from '../../../lib/email';
import { isFeeEnable } from '../../../config';
import classNames from 'classnames';

export const ServiceOrderResult = () => {
  const history = useHistory();
  const [reloading, setReloading] = useState<boolean>(false);
  const [detail, setDetail] = useState<IApiOrderListItem>();
  const matched = matchPath<{ orderID: string; studioId: string }>(
    location.pathname,
    '/studio/:studioId/fee/order-result/:orderID'
  );

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    if (!isFeeEnable()) {
      history.push('/404');
      return;
    }
    const orderID = matched?.params.orderID;
    const studioId = matched?.params.studioId;
    if (orderID && studioId) {
      const res = await getOrderDetail(orderID, studioId);
      setDetail(res);
    }
  };

  const reload = async () => {
    setReloading(true);
    await init();
    setReloading(false);
  };

  const renderContent = () => {
    if (!detail) {
      return null;
    }

    const statusTextConfig = OrderStatusConfig[detail.order_status];
    if (!statusTextConfig) {
      return null;
    }

    return (
      <div className={styles.content}>
        <div className={styles.title}>
          <span>
            {statusTextConfig.icon || null}
            {statusTextConfig.title}
          </span>
          <Button type="link" className={styles.refreshBtn} onClick={reload}>
            <SyncOutlined spin={reloading} />
            {getFormatMessage('refresh_status')}
          </Button>
          <Button
            className={classNames('gc-btn', 'gc-btn-default')}
            onClick={(event) => openContactMethod(event)}
          >
            {getFormatMessage('contact_us')}
          </Button>
        </div>
        {!!statusTextConfig.desc && statusTextConfig.desc}
        <div className={styles.footer}>
          <Button
            className={classNames('gc-btn', 'gc-btn-default')}
            onClick={() => {
              history.goBack();
            }}
          >
            {getFormatMessage('back')}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              const orderID = matched?.params.orderID;
              const studioId = matched?.params.studioId;
              history.push(
                `/studio/${studioId}/fee/order-manage/detail/${orderID}`
              );
            }}
          >
            {getFormatMessage('order_view_in_management')}
          </Button>
        </div>
      </div>
    );
  };

  return <div className={styles.orderPage}>{renderContent()}</div>;
};
